import React from 'react';
import { Link } from 'react-router-dom';
import Analytics from './Analytics';

export default function AnalyzeDashboard() {
  return (
    <div className="container mx-auto p-6 max-w-7xl">
      {/* Header */}
      <div className="mb-6">
        <div className="flex items-center gap-2 text-sm text-[#8A93A6] mb-2">
          <Link to="/app/analyze" className="hover:text-white">ANALYZE</Link>
          <span>/</span>
          <span className="text-white">Analytics</span>
        </div>
        <h1 className="text-3xl font-bold text-white mb-2">Analytics</h1>
        <p className="text-[#8A93A6]">Read-only performance insights and metrics</p>
      </div>

      {/* Analytics Component */}
      <Analytics />
    </div>
  );
}
